import { v4 as UuIdV4 } from 'uuid';

export const Uuid = {
  newV4: () => UuIdV4(),
};
